// Import the functions you need from the SDKs you need

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID
};


// Initialize Firebase
const appName = "AMA_APP";
let app;

// Check if an app with this name already exists to avoid duplication
const existingApp = getApps().find(a => a.name === appName);
if (existingApp) {
  app = existingApp;
} else {
  app = initializeApp(firebaseConfig, appName);
}

// Analytics only in browser
let analytics;
if (typeof window !== "undefined") {
    analytics = getAnalytics(app);
}

// Initialize Cloud Firestore and get a reference to the service
import { initializeFirestore } from "firebase/firestore";
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

export { app, analytics, db };